import { __rest } from "tslib";
import * as React from 'react';
const BuyNow = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M11 4a4 4 0 0 0-4 4H4.484a1.5 1.5 0 0 0-1.479 1.751l1.36 8A1.5 1.5 0 0 0 5.845 19H16.4v-1H5.844a.5.5 0 0 1-.493-.416l-1.36-8A.5.5 0 0 1 4.484 9H17.54a.5.5 0 0 1 .494.574l-.39 2.602.989.148.39-2.601A1.5 1.5 0 0 0 17.54 8H15a4 4 0 0 0-4-4Zm0 1a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3Z" }),
        React.createElement("path", { d: "m19.214 18.371 2.829-2.828-2.829-2.829-.707.707 1.621 1.622h-8.07v1h8.07l-1.621 1.62.707.708Z" })));
};
BuyNow.displayName = 'BuyNow';
export default BuyNow;
//# sourceMappingURL=BuyNow.js.map